/*
 * HTML converter for Code.
 */
export default {
  type: 'code',
  tagName: 'code'
}
